import { useMutation } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { previewDeleteLibrary } from "../api/libraryService";
export var useLibraryDeletePreview = function (onLoaded, onError) {
    var kyInstance = useOkapiKy();
    return useMutation({
        mutationFn: function (libraryId) {
            return previewDeleteLibrary(kyInstance, libraryId);
        },
        onSuccess: onLoaded,
        onError: onError,
    });
};
